/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MonitoringTube } from "./MonitoringTube";
import {
  MonitoringTubeFromJSON,
  MonitoringTubeFromJSONTyped,
  MonitoringTubeToJSON,
  MonitoringTubeToJSONTyped,
} from "./MonitoringTube";

/**
 *
 * @export
 * @interface ApiGmwMonitoringtubesList200Response
 */
export interface ApiGmwMonitoringtubesList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmwMonitoringtubesList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmwMonitoringtubesList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwMonitoringtubesList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<MonitoringTube>}
   * @memberof ApiGmwMonitoringtubesList200Response
   */
  results: Array<MonitoringTube>;
}

/**
 * Check if a given object implements the ApiGmwMonitoringtubesList200Response interface.
 */
export function instanceOfApiGmwMonitoringtubesList200Response(
  value: object
): value is ApiGmwMonitoringtubesList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmwMonitoringtubesList200ResponseFromJSON(
  json: any
): ApiGmwMonitoringtubesList200Response {
  return ApiGmwMonitoringtubesList200ResponseFromJSONTyped(json, false);
}

export function ApiGmwMonitoringtubesList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwMonitoringtubesList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(MonitoringTubeFromJSON),
  };
}

export function ApiGmwMonitoringtubesList200ResponseToJSON(
  json: any
): ApiGmwMonitoringtubesList200Response {
  return ApiGmwMonitoringtubesList200ResponseToJSONTyped(json, false);
}

export function ApiGmwMonitoringtubesList200ResponseToJSONTyped(
  value?: ApiGmwMonitoringtubesList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(MonitoringTubeToJSON),
  };
}
